<template>
  <div class="previous-cashflow-view">
    <div class="household-name-container" v-bind:class="{ 'with-notification': showNotification }">
      <div class="title">היי {{ householdName }}</div>
    </div>
    <div class="cashflow-with-notification" v-bind:class="{ 'shadow-container': showNotification }">
      <div class="notification-container">
        <cashflow-tour-notification v-if="showNotification"
                                    :month-name="monthName"
                                    :on-open-tour="setDuringTour"
                                    :on-close-tour="closeTour"/>
      </div>
      <div class="cashflow-container"  v-bind:class="{ 'with-notification': showNotification }">
        <cashflow-view/>
        <div class="button-container">
          <riseup-button :action="finishReview"
                         :size="'normal'"
                         :title="'סיימתי'"
                         :subtitle="`להכנת תזרים ${ nextMonthName }`"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapGetters, mapActions, mapState } from 'vuex';
import Segment from '../../../../../Segment';
import CashflowView from '../../navigation-pages/cashflow-app/cashflow-view/CashflowView.vue';
import CashflowTourNotification from '../../navigation-pages/cashflow-app/notification/notification-types/CashflowTourNotification.vue';
import cashflowHistory from '../../../../../store/utilities/cashflow-history';

export default {
  name: 'PreviousCashflowView',
  components: {
    CashflowView,
    CashflowTourNotification,
    RiseupButton: BaseUI.RiseupButton,
  },
  async created() {
    this.startLoading(this.$options.name);
    await this.initBudgets({ budgetDate: this.prevBudgetDate, allowViewCurrentMonth: false });
    this.doneLoading(this.$options.name);
  },
  computed: {
    ...mapGetters('session', ['householdName']),
    ...mapGetters('cashflowView', ['monthName']),
    ...mapState('cashflowView', ['currentBudgetDate']),
    ...mapGetters('cashflowTour', ['isPreTour']),
    nextMonthName() {
      return cashflowHistory.getFullMonthName(this.currentBudgetDate);
    },
    showNotification() {
      return this.isPreTour;
    },
    prevBudgetDate() {
      return cashflowHistory.getPrevBudgetDate(cashflowHistory.getCurrentBudgetDate());
    },
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
    ...mapActions('cashflowTour', ['setDuringTour', 'setPostTour', 'setFullCashflowReviewFinished']),
    ...mapActions('cashflowView', ['initBudgets']),
    closeTour() {
      this.setPostTour();
      window.scrollTo(0, 0);
    },
    finishReview() {
      Segment.trackUserInteraction('CashflowTourFinishReviewClicked');
      this.setFullCashflowReviewFinished();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .previous-cashflow-view {
    .anti-shadow {
      overflow: hidden;
      width: 100%;
    }

    .household-name-container {
      width: 100%;

      &.with-notification {
        padding-bottom: 20px;
        border-bottom: 1px solid $riseup_gray_0;
      }

      .title {
        width: 100%;
        @include responsive-padding;
        display: inline-block;
        width: 320px;
        font-family: GretaSans;
        font-size: 24px;
        line-height: 32px;
        padding: 20px 0;
      }
    }

    .cashflow-with-notification {
      &.shadow-container {
        background-color: $riseup_white_1;
      }

      .notification-container {
        padding-bottom: 10px;
      }

      .cashflow-container {
        &.with-notification {
          background-color: $riseup_white;
          border-radius: 8px 8px 0 0;
          box-shadow: 0 -1px 5px 0 rgba(0, 0, 0, 0.2);
          padding-top: 16px;
          height: 100%
        }

        .button-container {
          text-align: center;
          width: 100%;
          padding: 20px 0 36px;
        }
      }
    }

    .shadow-container {
      background-color: $riseup_white_1;
    }
  }
</style>
